import React, { useState } from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import { ACCOUNT_REVIEW } from "utils";
import { Button } from "components/common";
import { SUCCESS_STATUS } from "utils/constants";

const AccountReview = () => {
  const [error, setError] = useState("");
  const [generateAccountReview, { loading }] = useLazyQuery(ACCOUNT_REVIEW, {
    onCompleted: data => {
      const {
        accountReview: { status, data: accountReviewReport, message, fileName }
      } = data;
      if (status === SUCCESS_STATUS) {
        downloadTxtFile(fileName, accountReviewReport);
      } else {
        setError(message || "Error generating file");
      }
    }
  });

  const downloadTxtFile = (fileName, data) => {
    const element = document.createElement("a");
    const file = new Blob([data], {
      type: "text/plain"
    });
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
  };

  return (
    <div>
      {error && <p className="text-red-600">{error}</p>}
      <Button
        green
        paddingHorizontal={22}
        paddingVertical={10}
        disabled={loading}
        onClick={generateAccountReview}
      >
        Generate Account Review
      </Button>
    </div>
  );
};

export default AccountReview;
